import { OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { UserProfileService } from '../user-profile/user-profile.service';
import { LanguageService } from '../../../core/language/language.service';
import { AuthService } from '../../../core/auth/auth.service';
import { ItauUserIdleService } from '../../../core/security/itau-user-idle.service';
var HeaderContainerComponent = /** @class */ (function () {
    function HeaderContainerComponent(userProfileService, itauUserIdleService, languageService, authService) {
        this.userProfileService = userProfileService;
        this.itauUserIdleService = itauUserIdleService;
        this.languageService = languageService;
        this.authService = authService;
        this.myControl = new FormControl();
        this.profile = new UserProfileComponent(userProfileService, itauUserIdleService, languageService, authService, this._window, null, null);
    }
    HeaderContainerComponent.prototype.ngOnInit = function () {
        this.contextOpen = false;
    };
    HeaderContainerComponent.prototype.onIsFocused = function (event) {
        this.searchBarIsFocused = event;
    };
    HeaderContainerComponent.prototype.openContext = function () {
        this.contextOpen = true;
    };
    HeaderContainerComponent.prototype.onCloseContext = function (closeEvent) {
        this.contextOpen = !closeEvent;
    };
    HeaderContainerComponent.prototype.onMenuRetrieval = function (retrievedMenu) {
        this.menu = retrievedMenu;
    };
    return HeaderContainerComponent;
}());
export { HeaderContainerComponent };
